import { render } from "./addConfig.vue?vue&type=template&id=80c74f7a&scoped=true"
import script from "./addConfig.vue?vue&type=script&lang=js"
export * from "./addConfig.vue?vue&type=script&lang=js"

import "./addConfig.vue?vue&type=style&index=0&id=80c74f7a&lang=scss&scoped=true"

import exportComponent from "/home/pages/train-manage/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80c74f7a"]])

export default __exports__